import { Box, Card, RichTextReader, Stack, Typography } from "@compass/core";
import { CopyLinkButton } from "components/common/CopyLinkButton";
import { UserManualSubSectionDto } from "generated/openApi";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ApiService from "services/apiService";

export const UserManualContent = () => {
  const { uniqueIdentifier } = useParams();
  const [selectedSubSection, setSelectedSubSection] = useState<UserManualSubSectionDto>();
  const [linkCopy, setLinkCopy] = useState<boolean>(false);

  useEffect(() => {
    ApiService.userManual.getUserManualSubSectionIdentifier(uniqueIdentifier).then((response) => {
      setSelectedSubSection(response);
    });
    setLinkCopy(false);
  }, [uniqueIdentifier]);

  return (
    <Card>
      {!selectedSubSection && <Typography>Please select a Section</Typography>}
      {selectedSubSection && (
        <Box>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="inherit">{selectedSubSection.name}</Typography>
            <CopyLinkButton showCheck={linkCopy} setShowCheck={setLinkCopy} />
          </Stack>

          {selectedSubSection.content && <RichTextReader html={selectedSubSection.content.content} />}
          {!selectedSubSection.content && <Typography>No content yet.</Typography>}
        </Box>
      )}
    </Card>
  );
};
